const state = {
  currentAlert: null,
  closedInstallPopup: false,
};

const getters = {
  getCurrentAlert(state) {
    return state.currentAlert;
  },
  hasAlert(state) {
    return state.currentAlert != null;
  },
};

const actions = {};

const mutations = {
  setAlert(state, payload) {
    state.currentAlert = payload;
  },
  resetAlert(state) {
    state.currentAlert = null;
  },
  closeInstallPopup(state) {
    state.closedInstallPopup = true;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
